import {ErrorUtil} from "base/error/utilities";

const baseUrl = "https://www.cartociudad.es/geocoder/api/geocoder/";

const CartoCiudadService = {
    get(path, params) {
        return fetch(`${baseUrl}${path}${params}`, {
            method: "GET",
        })
            .then(ErrorUtil.handleFetchResponse)
            .then(data => {
                console.log({data});
                return data;
            })
            .catch(error => {
                ErrorUtil.handleError(error);
            });
    },
};

export default CartoCiudadService;
